export default function FieldLabel({ label, required }) {
  return (
    <span>
      {label}
      {required && <span style={{ color: "red", marginLeft: 2 }}>*</span>}
    </span>
  );
}
